import { DatePicker as CarbonDatePicker, DatePickerInput } from "@carbon/react";

import { IDatePickerProps } from "./DatePicker";
import { appConfig } from "../../configs";
// import calendarIcon from "../../assets/icons/calendar.svg";

export const View = ({
  name,
  inputType,
  placeholder,
  // minDate,
  // maxDate,
  onChange: wrapperOnChange,
  onClose: wrapperOnClose,
  onOpen: wrapperOnOpen,
  onRenderedInputChange: onInputChange,
  onRenderedInputClick: onInputClick,
  ...rest
}: IDatePickerProps) => {
  return (
    <CarbonDatePicker
      datePickerType="single"
      type={inputType}
      // dateFormat={appConfig.dateFormat5}
      size="sm"
      className="date-range--picker"
      onChange={wrapperOnChange ?? function noRefCheck() {}}
      onClose={wrapperOnClose ?? function noRefCheck() {}}
      onOpen={wrapperOnOpen ?? function noRefCheck() {}}
      {...rest}
    >
      <DatePickerInput
        id={name}
        // light
        datePickerType="simple"
        placeholder={placeholder}
        autocomplete="off"
        // value={startDate}
        onOpen={function (e: string) {
          // clear date range
        }}
        onChange={onInputChange}
        onClick={onInputClick}
      />
    </CarbonDatePicker>
  );
};
